import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { firstValueFrom } from "rxjs";
import { HolidayModel } from "../models/holiday-model";

@Injectable({
    providedIn: "root",
})
export class WorkdayOrganizerDataService extends ApiDataService {
    constructor() {
        super("workdayorganizer");
    }

    public async GetWorkDays(): Promise<string[]> {
        let url = "/workdays";
        return await firstValueFrom(this.get(url));
    }

    public async GetHolidays(): Promise<HolidayModel[]> {
        let url = "/holidays";
        return await firstValueFrom(this.get(url));
    }

    public async StoreWorkDays(models: string[]): Promise<string[]> {
        let url = "/workdays";
        return await firstValueFrom(this.post(models, url));
    }

    public async StoreHolidays(models: HolidayModel[]): Promise<HolidayModel[]> {
        let url = "/holidays";
        return await firstValueFrom(this.post(models, url));
    }
}
